import { Component } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { DesignService } from 'src/app/state';
import { ConstructionDetailsService } from 'src/app/state/construction/construction-details.service';

@Component({
  selector: 'em-construction-details',
  templateUrl: './construction-details.component.html',
  standalone: false,
})
export class ConstructionDetailsComponent {
  public construction$ = this.constructionDetails.details$;
  public loading$ = combineLatest([
    this.designService.loading$,
    this.constructionDetails.loading$,
  ]).pipe(map(([designLoading, constructionLoading]) => designLoading || constructionLoading));

  public error$ = this.constructionDetails.error$;

  public readonly errorMessage$ = this.error$.pipe(
    map((err) => {
      if (typeof err === 'string') return err;
      if (err instanceof Error) return err.message;

      return undefined;
    })
  );

  public constructor(
    private readonly constructionDetails: ConstructionDetailsService,
    private readonly designService: DesignService
  ) {}
}
